import { Anchor, ArrowLeftRight, BedDouble, Camera, Car, Info, Plane, Ship, TrainFront, UtensilsCrossed } from "lucide-react";

export const EVENT_TYPES = [
  { value: "flight", label: "Flight", icon: Plane },
  { value: "lodging", label: "Lodging / Hotel", icon: BedDouble },
  { value: "activity", label: "Activity", icon: Camera },
  { value: "transport", label: "Transportation", icon: Car },
  { value: "cruise", label: "Cruise", icon: Ship },
  { value: "port", label: "Port Information", icon: Anchor },
  { value: "info", label: "Information", icon: Info },
  { value: "restaurant", label: "Restaurant", icon: UtensilsCrossed },
  { value: "transfer", label: "Transfer", icon: ArrowLeftRight },
  { value: "train", label: "Train", icon: TrainFront },
];

const BY_VALUE = Object.fromEntries(EVENT_TYPES.map((t) => [t.value, t]));

export const eventType = (value) => BY_VALUE[value] || null;
